'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');
const timespan=require('pulsar-utils/dist-es6/time/timespan');

const MillisecondsPerHour=timespan.fromHours(1).totalMilliseconds();let

TwentyFourHourAxisLabelDirective=function(_BaseControllerBacked){_inherits(TwentyFourHourAxisLabelDirective,_BaseControllerBacked);function TwentyFourHourAxisLabelDirective(){_classCallCheck(this,TwentyFourHourAxisLabelDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(TwentyFourHourAxisLabelDirective,[{key:'objectBindings',get:function()
{return['timeFormatter']}},{key:'controller',get:function()

{return TwentyFourHourAxisLabelController}}]);return TwentyFourHourAxisLabelDirective}(BaseControllerBackedDirective);let


TwentyFourHourAxisLabelController=function(_BaseResizableDirecti){_inherits(TwentyFourHourAxisLabelController,_BaseResizableDirecti);_createClass(TwentyFourHourAxisLabelController,null,[{key:'$inject',get:function()
{return['$scope','$element','$window']}}]);

function TwentyFourHourAxisLabelController($scope,$element,$window){_classCallCheck(this,TwentyFourHourAxisLabelController);var _this2=_possibleConstructorReturn(this,
_BaseResizableDirecti.call(this,$scope,$element,$window));

_this2._svgElement=null;

_this2.oneDayInterval=new TimeInterval('2014-01-01T00:00:00.000Z','2014-01-02T00:00:00.000Z');

$scope.$watch('controller.dimensions.width',function(){return _this2._updateScale()});
$scope.$watch('controller.scale',function(){return _this2._render()});return _this2;
}TwentyFourHourAxisLabelController.prototype.

_updateScale=function _updateScale(){
if(_.exists(this.dimensions)&&_.exists(this.dimensions.width)){
this._scale=d3.time.scale.utc().domain([this.oneDayInterval.start,this.oneDayInterval.end]).range([0,this.dimensions.width]);
}else{
this._scale=null;
}
};TwentyFourHourAxisLabelController.prototype.





_render=function _render(){
if(!this._dimensionsValid){
return;
}

if(!_.exists(this.scale)){
return;
}

this._refreshSvg();

let xAxisGroup=d3.select(this._svgElement).append('g').attr({
class:'x-axis',
transform:`translate(0, ${this.dimensions.height})`}).
call(this._drawTimeAxis());

xAxisGroup.
selectAll('line').
data(this.scale.ticks(this.oneDayInterval.duration.totalMilliseconds()/MillisecondsPerHour),_.identity).
enter().
append('line').
attr({
class:'minor',
y1:0,
y2:-3,
x1:this.scale,
x2:this.scale});


xAxisGroup.
selectAll('text').
style({
"text-anchor":'start'});

};TwentyFourHourAxisLabelController.prototype.

_drawTimeAxis=function _drawTimeAxis(){
return d3.svg.axis().
scale(this.scale).
orient('top').
ticks(d3.time.hours.utc,2).
innerTickSize(7).
outerTickSize(1).
tickFormat(this.timeFormatter);
};TwentyFourHourAxisLabelController.prototype.

_refreshSvg=function _refreshSvg(){
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

this._$element.append(`<svg width="${this.dimensions.width}" height="${this.dimensions.height}"></svg>`);
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];
};_createClass(TwentyFourHourAxisLabelController,[{key:'scale',get:function(){return this._scale}}]);return TwentyFourHourAxisLabelController}(BaseResizableDirectiveController);


module.exports=TwentyFourHourAxisLabelDirective;
//# sourceMappingURL=twentyFourHourAxisLabelDirective.js.map
